import { config } from '@/config'

export const termsOfServiceUrl = () => {
  switch (config.applicationKey) {
    case 'playdeck':
      return 'https://utoniq.notion.site/PLAYDECK-1b498c44c7d580a6ab10e8f58db0cb31'
    default:
      return 'https://link.utnq.in/terms'
  }
}
